/* eslint-disable array-callback-return */
import React, { useEffect, useState } from 'react';

// router
import { useLocation, useNavigate, useParams } from 'react-router-dom';

// icon
import { MdOutlineDashboard, MdOutlinePeopleOutline } from 'react-icons/md';
import { GoSignOut } from 'react-icons/go';
// import { IoSettingsOutline } from 'react-icons/io5';
import { FiSend, FiBell } from 'react-icons/fi';
import defaultProfile from '../../assets/images/default_profile.jpeg';

// asset
import dpLogo from '../../assets/images/dp-logo.png';
import { getUserProfileImageFromMomthera } from '../../services/apis/momthera/user';
import CommonModal from '../modal/CommonModal';

const menu = {
	dtx001: [
		{
			key: 'dashboard',
			value: 'Dashboard',
			path: 'dashboard',
			subItems: [],
			icon: <MdOutlineDashboard size="1.5rem" />,
		},
		{
			key: 'patient-manage',
			value: '환자 관리',
			path: 'patient-manage',
			subItems: [{ key: 'list', value: '환자 전체 리스트', path: 'list', isSelectable: true }],
			icon: <MdOutlinePeopleOutline size="1.5rem" />,
		},
		// {
		// 	key: 'system-setting',
		// 	value: '시스템 관리',
		// 	path: 'system-setting',
		// 	subItems: [
		// 		{ key: 'institution', value: '의료기관 설정', path: 'institution', isSelectable: true },
		// 		{ key: 'user', value: '사용자 설정', path: 'user', isSelectable: true },
		// 		{ key: 'auth', value: '권한 설정', path: 'auth', isSelectable: true }
		// 	],
		// 	icon: <IoSettingsOutline size="1.5rem" />
		// },
		{
			key: 'push-notification',
			value: '단체 메시지',
			path: 'push-notification',
			subItems: [],
			icon: <FiSend size="1.5rem" />,
		},
		{
			key: 'mypage',
			value: '마이페이지',
			path: 'mypage',
			subItems: [],
			icon: <FiBell size="1.5rem" />,
		},
	],
	dtx002: [
		// {
		// 	key: 'dashboard',
		// 	value: 'Dashboard',
		// 	path: 'dashboard',
		// 	subItems: [],
		// 	icon: <MdOutlineDashboard size="1.5rem" />
		// },
		{
			key: 'patient-manage',
			value: '환자 관리',
			path: 'patient-manage',
			subItems: [{ key: 'list', value: '환자 전체 리스트', path: 'list', isSelectable: true }],
			icon: <MdOutlinePeopleOutline size="1.5rem" />,
		},
		{
			key: 'push-notification',
			value: '단체 메시지',
			path: 'push-notification',
			subItems: [],
			icon: <FiSend size="1.5rem" />,
		},
		{
			key: 'mypage',
			value: '마이페이지',
			path: 'mypage',
			subItems: [],
			icon: <FiBell size="1.5rem" />,
		},
	],
	dtx006: [
		{
			key: 'dashboard',
			value: '대시보드',
			path: 'dashboard',
			subItems: [],
			icon: <MdOutlineDashboard size="1.5rem" />,
		},
		{
			key: 'patient-manage',
			value: '환자관리',
			path: 'patient-manage',
			subItems: [{ key: 'list', value: '환자 전체 리스트', path: 'list', isSelectable: true }],
			icon: <MdOutlinePeopleOutline size="1.5rem" />,
		},
		// {
		// 	key: 'push-notification',
		// 	value: '단체 메시지',
		// 	path: 'push-notification',
		// 	subItems: [],
		// 	icon: <FiSend size="1.5rem" />
		// },
		{
			key: 'mypage',
			value: '마이페이지',
			path: 'mypage',
			subItems: [],
			icon: <FiBell size="1.5rem" />,
		},
	],
};

function DashboardSidebar({ type }) {
	const { pid } = useParams();
	const navigate = useNavigate();
	const location = useLocation();

	const [profileImg, setProfileImg] = useState(null);

	const [selectedMenu, setSelectedMenu] = useState({
		menu: 'dashboard',
		submenu: '',
	});

	const [showSignoutModal, setShowSignoutModal] = useState(false);

	function onSelectSidebarMenu(idx) {
		const targetMenukey = menu[type][idx].key;
		const targetSubMenuKey = menu[type][idx].subItems.length ? menu[type][idx].subItems[0].key : '';

		setSelectedMenu({ menu: targetMenukey, submenu: targetSubMenuKey });

		const targetURL = targetSubMenuKey
			? `/${type}/${targetMenukey}/${targetSubMenuKey}`
			: `/${type}/${targetMenukey}`;

		if (window.location.pathname !== targetURL) {
			navigate(targetURL);
		}
	}

	function onSelectSidebarSubMenu(idx, subIdx) {
		if (menu[type][idx].subItems[subIdx].isSelectable === true) {
			const targetMenukey = menu[type][idx].key;
			const targetSubMenuKey = menu[type][idx].subItems[subIdx].key;

			setSelectedMenu({ menu: targetMenukey, submenu: targetSubMenuKey });

			const targetURL = `/${type}/${targetMenukey}/${targetSubMenuKey}`;

			if (window.location.pathname !== targetURL) {
				navigate(targetURL);
			}
		}
	}

	const signOut = () => {
		localStorage.removeItem(`${type}token`);
		localStorage.removeItem('saveId');
		sessionStorage.removeItem('hasShownLoginToast');
		navigate(`/sign-in/${type}`);
	};

	async function getUserProfileImageFromAPI() {
		try {
			const res = await getUserProfileImageFromMomthera();
			if (Math.floor(res.status / 100) === 2 && res.data) {
				const imgURL = URL.createObjectURL(res.data);
				setProfileImg(imgURL || null);
			} else {
				throw new Error();
			}
		} catch {
			setProfileImg(null);
		}
	}

	const SignoutModalBody = <div className="mypage_modal_body">로그아웃 하시겠습니까?</div>;

	const SignoutModalFooter = (
		<div className="modalfooter" style={{ gap: '1rem' }}>
			<button className="submitButton__rounded sm" onClick={signOut}>
				확인
			</button>
			<button className="cancelButton__rounded sm" onClick={() => setShowSignoutModal(false)}>
				취소
			</button>
		</div>
	);

	useEffect(() => {
		if (type === 'dtx006') {
			getUserProfileImageFromAPI();
		}
	}, [type]);

	useEffect(() => {
		const curPathname = window.location.pathname.split('/');
		const curMenu = curPathname[2];
		const curSubMenu = curPathname.length === 3 ? '' : curPathname[3];

		setSelectedMenu({ menu: curMenu, submenu: curSubMenu });

		// [환자 관리 > 환자 상세 페이지]가 아닌데 session에 firstTrainingStart 정보가 있으면 삭제하기
		if (!(location.pathname.includes('/dtx001/patient-manage/list') && pid)) {
			if (sessionStorage.getItem('firstTrainingStart')) {
				sessionStorage.removeItem('firstTrainingStart');
			}
		}
	}, [location.pathname]);

	return (
		<div className="dashboardSidebar" style={{ paddingTop: type === 'dtx006' ? '1.25rem' : null }}>
			<div className="dashboardSidebar__content">
				{type === 'dtx006' && (
					<div className="dashboardSidebar__content__menu">
						<GoSignOut
							className="dashboardSidebar__content__signout"
							onClick={() => setShowSignoutModal(true)}
						/>
						<img
							className="dashboardSidebar__content__profileImg"
							src={profileImg || defaultProfile}
							alt="profile"
						/>
					</div>
				)}
				{menu[type].map((item, idx) => {
					return (
						<div
							key={item.key}
							className="dashboardSidebar__content__item"
							style={{
								border:
									selectedMenu.menu === item.key ? '1px solid #0b4b6d' : '1px solid transparent',
							}}
						>
							<div
								className="dashboardSidebar__content__item__upper"
								style={{
									backgroundColor: selectedMenu.menu === item.key ? '#f4f6f8' : 'transparent',
									borderRadius:
										selectedMenu.menu === item.key && item.subItems.length ? '5px 5px 0 0' : '5px',
								}}
								role="none"
								onClick={() => onSelectSidebarMenu(idx)}
							>
								<div
									className="dashboardSidebar__content__item__upper__icon"
									style={{ color: item.key === selectedMenu.menu ? '#0b4b6d' : 'black' }}
								>
									{item.icon}
								</div>
								<div
									className="dashboardSidebar__content__item__upper__content"
									style={{ color: item.key === selectedMenu.menu ? '#0b4b6d' : 'black' }}
								>
									{item.value}
								</div>
							</div>
							{item.key === selectedMenu.menu ? (
								item.subItems.map((subItem, subIdx) => {
									return (
										<div
											key={subItem.key}
											className="dashboardSidebar__content__item__lower"
											role="none"
											onClick={() => onSelectSidebarSubMenu(idx, subIdx)}
											style={{
												backgroundColor:
													item.key === selectedMenu.menu && subItem.key === selectedMenu.submenu
														? '#f4f6f8'
														: 'transparent',
												borderBottomLeftRadius: subIdx === item.subItems.length - 1 ? '5px' : 0,
												borderBottomRightRadius: subIdx === item.subItems.length - 1 ? '5px' : 0,
											}}
										>
											<div className="dashboardSidebar__content__item__lower__icon" />
											<div
												className="dashboardSidebar__content__item__lower__content"
												style={{
													color:
														item.key === selectedMenu.menu && subItem.key === selectedMenu.submenu
															? '#0b4b6d'
															: 'black',
												}}
											>
												- {subItem.value}
											</div>
										</div>
									);
								})
							) : (
								<div />
							)}
						</div>
					);
				})}
			</div>
			<div className="dashboardSidebar__footer">
				<img src={dpLogo} alt="digital-pharm" className="dashboardSidebar__footer__icon" />
			</div>
			<CommonModal
				header="로그아웃"
				body={SignoutModalBody}
				footer={SignoutModalFooter}
				show={showSignoutModal}
				setClose={() => setShowSignoutModal(false)}
				size="sm"
			/>
		</div>
	);
}

export default DashboardSidebar;
